import React from "react";
import { heroStats } from "../mock";
import { LogoMark } from "./Logo";

const Hero = () => {
  return (
    <section className="relative overflow-hidden border-b border-white/10 pt-28 pb-14 md:pb-20">
      {/* Exact reference background: purple + green radials over a deep gradient */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(circle at 12% 20%, rgba(179,92,255,0.42), transparent 30%), radial-gradient(circle at 88% 15%, rgba(140,255,0,0.2), transparent 25%), linear-gradient(140deg,#050005,#09000f 48%,#100019)",
        }}
      />
      <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-black to-transparent" />

      <div className="relative z-10 max-w-6xl mx-auto px-5 sm:px-8">
        <div className="fade-up">
          <LogoMark />
        </div>

        <p className="kicker mt-8" style={{ color: "#8cff00" }}>Hustle Sold Separately</p>
        <h1
          className="font-display font-extrabold uppercase text-white mt-3 leading-[0.9] tracking-tight max-w-5xl fade-up"
          style={{ fontSize: "clamp(2.6rem, 7vw, 5.5rem)", animationDelay: "0.06s" }}
        >
          First Season <span style={{ color: "#d8b4fe" }}>Artist Information.</span>
        </h1>

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_320px] gap-8 lg:items-end">
          <div className="max-w-3xl fade-up" style={{ animationDelay: "0.1s" }}>
            <p className="font-serif-body font-bold text-white text-[1.06rem] md:text-lg">
              Congratulations! Your demo was featured during First Season of Hustle Sold Separately.
            </p>
            <p className="font-serif-body text-white/70 mt-4 text-[1.02rem] md:text-lg leading-relaxed">
              As we move through post-production, we're collecting additional information to help us tell
              your story. If your demo appears in the final cut, your responses may be featured throughout
              the episode as on-screen pop-ups, artist introductions, social media content, promotional
              materials, and other HSS Feed marketing.
            </p>
            <p className="font-serif-body text-white/70 mt-4 text-[1.02rem] md:text-lg leading-relaxed">
              This is your opportunity to help viewers discover who you are, not just what you sound like.
              Answer honestly and authentically. The most memorable responses are specific, personal, and
              uniquely you.
            </p>
          </div>

          <div
            className="grid grid-cols-3 gap-2 rounded-3xl p-3 backdrop-blur fade-up"
            style={{
              border: "1px solid rgba(196,132,252,0.3)",
              background: "rgba(0,0,0,0.55)",
              boxShadow: "0 0 55px rgba(179,92,255,0.18)",
              animationDelay: "0.16s",
            }}
          >
            {heroStats.map((s) => (
              <div key={s.label} className="rounded-2xl border border-white/10 bg-white/[0.04] px-2 py-4 text-center">
                <p className="font-display font-black text-xl sm:text-2xl" style={{ color: "#8cff00" }}>{s.value}</p>
                <p className="mt-1 text-[10px] font-black uppercase tracking-[0.12em] text-white/50">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
